import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MakeMoovContainerComponent } from './make-moov-container/make-moov-container.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper'; 
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { SelectIssueTypeComponent } from './select-issue-type/select-issue-type.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectIssueComponent } from './select-issue/select-issue.component';
import { SelectMoovComponent } from './select-moov/select-moov/select-moov.component'; 
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MakeMoovHeaderWebComponent } from './make-moov-container/make-moov-header-web/make-moov-header-web.component';
import { MakeMoovHeaderMobileComponent } from './make-moov-container/make-moov-header-mobile/make-moov-header-mobile.component';
import { MoovTileWebComponent } from './select-moov/select-moov/moov-tile-web/moov-tile-web.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    MakeMoovContainerComponent,
    SelectIssueTypeComponent,
    SelectIssueComponent,
    SelectMoovComponent,
    MakeMoovHeaderWebComponent,
    MakeMoovHeaderMobileComponent,
    MoovTileWebComponent
  ],
  imports: [
    MoovCommonModule,
    CommonModule,
    MatSidenavModule,
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatGridListModule,
    MatDividerModule,
    MatIconModule,
    // GenderPipe,
    // TranslateByGenderPipe
  ],
  exports: [
    MakeMoovContainerComponent
  ]
})

export class MakeMoovModule {
   }
